import 'twin.macro';
import 'styled-components/macro';
import { useState } from 'react';
import styled from 'styled-components';

import { Logo } from 'play/atoms/logo/Logo';

import { InstruqtBrandingModal } from '../instruqt-branding-modal/InstruqtBrandingModal';
import { ReactComponent as RefreshIcon } from './images/refresh.svg';

export interface HeaderProps {
  children?: React.ReactNode;
  hideRefresh?: boolean;
  onClickRefresh?(): void;
}

export const Header = ({ children, hideRefresh = false, onClickRefresh }: HeaderProps) => {
  const [showBrandingModal, setShowBrandingModal] = useState(false);

  return (
    <div tw="flex bg-blue h-[50px]">
      <Logo tw="h-full cursor-pointer" location="Assignment" type="color" onClick={() => setShowBrandingModal(true)} />
      <InstruqtBrandingModal open={showBrandingModal} onClose={() => setShowBrandingModal(false)} />

      <div tw="grow flex overflow-x-auto all-child:(flex-1 shrink-0 basis-10 max-w-fit)">{children}</div>

      <div tw="flex gap-2 px-2 text-white">
        {!hideRefresh && (
          <IconContainer onClick={onClickRefresh}>
            <RefreshIcon />
          </IconContainer>
        )}
      </div>
    </div>
  );
};

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  user-select: none;

  svg {
    width: 15px;
  }
`;
